import { styled, Box, Typography, Button, IconButton } from "@mui/material";

export const CartItemContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(1.5),
  gap: theme.spacing(2),
  borderBottom: "1px solid #ccc",
  "&:last-child": { borderBottom: "none" },
  minHeight: 120,
  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing(1),
    gap: theme.spacing(1),
    minHeight: 90,
  },
  "@media (max-width: 400px)": {
    flexDirection: "column",
    alignItems: "center",
  },
}));

export const CartItemImage = styled("img")(({ theme }) => ({
  width: 75,
  height: 75,
  flexShrink: 0,
  borderRadius: theme.shape.borderRadius * 2,
  marginLeft: theme.spacing(2),
  [theme.breakpoints.down("sm")]: {
    width: 50,
    height: 50,
    marginLeft: theme.spacing(0.5),
  },
}));

export const CartItemDetails = styled(Box)(({ theme }) => ({
  flex: 4,
  minWidth: 120,
  paddingRight: theme.spacing(1),
  overflow: "hidden",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
}));

export const CartItemName = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  fontFamily: "Poppins",
  fontSize: "1.1rem",
  whiteSpace: "normal",
  overflow: "visible",
  textOverflow: "unset",
  wordBreak: "break-word",
  marginBottom: theme.spacing(0.5),
  [theme.breakpoints.down("sm")]: {
    fontSize: "0.9rem",
  },
}));

export const QuantityText = styled(Typography)(({ theme }) => ({
  fontSize: "0.8rem",
  [theme.breakpoints.down("sm")]: {
    fontSize: "0.7rem",
  },
}));

export const PriceText = styled(Typography)(({ theme }) => ({
  color: "#50B83C",
  fontWeight: 700,
  fontFamily: "Roboto",
  fontSize: "1rem",
  textAlign: "center",
  paddingRight: theme.spacing(2),
  [theme.breakpoints.down("sm")]: {
    fontSize: "0.9rem",
    paddingRight: theme.spacing(0.5),
  },
}));

export const QuantityButton = styled(Button)(({ theme }) => ({
  minWidth: 0,
  padding: theme.spacing(1),
  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing(0.5),
  },
}));

export const DeleteButton = styled(IconButton)(() => ({
  padding: "0.5em",
  "& img": {
    width: "2em",
    height: "2em",
  },
}));

export const ActionsContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  gap: theme.spacing(1),
  alignSelf: "center",
  flexWrap: "wrap",
  [theme.breakpoints.down("sm")]: {
    gap: theme.spacing(0.5),
    justifyContent: "space-between",
    width: "100%",
    alignSelf: "center",
  },
}));

export const QuantityContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1),
  minWidth: 100,
  justifyContent: "center",
}));
